<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-top
          class="d-md-flex"
          outlined
          :useBtnList="[
            'btnSearch' //check
          ]"
          @btnSearch="btnSearch()"
        >
          <template v-slot:body>
            <v-layout column>
              <v-row no-gutters class="center pa-2 pb-0">
                <v-col cols="12" md="2">
                  <v-select
                    label="Tug-Boat"
                    v-model="tugBoat"
                    :items="listTugBoat"
                    :item-value="`code`"
                    :item-text="`name`"
                    color="primary"
                    class="required mx-1 rounded-0"
                    :prepend-inner-icon="'$search'"
                    dense
                    outlined
                    clearable
                    @change = "btnSearch()"
                  ></v-select>
                </v-col>
                <i-label :label="'Moving Date : '" class="pl-2"/>
                <v-col cols="12" md="2">
                   <DxDateBox                        
                        :value="movDate"
                        height="30px"
                        display-format="yyyy-MM-dd"
                        :acceptCustomValue="false"
                        @value-changed="e => {movDate = e.value && getStrFormat(e.value)}"
                    />
                  <!-- <div class="xy-center">
                    <div class="mr-2">
                      <v-menu ref="fromDate" :close-on-content-click="false" :return-value.sync="movDate" offset-y min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            color="primary"
                            class="required mx-0 rounded-0"
                            :prepend-inner-icon="'$calendar'"
                            v-model="movDate"
                            label="Moving Date"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            hide-details
                            dense
                            outlined
                            clearable
                          />
                        </template>
                        <v-date-picker v-model="movDate" no-title scrollable>
                          <v-spacer />
                          <v-btn text @click="$refs.fromDate.isActive = false">
                            Cancel
                          </v-btn>
                          <v-btn text @click="$refs.fromDate.save(movDate)">
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </div>
                  </div> -->
                </v-col>

                <i-button :text="'Copy To =>'" :isCustom="true" :icon="'copy'" role="" class="pl-2" @click="btnCopy" />
                <v-col cols="12" md="2">
                  <v-select
                    label="Tug-Boat To"
                    v-model="tugBoatCopy"
                    :items="listTugBoat"
                    :item-value="`code`"
                    :item-text="`name`"
                    color="primary"
                    class="required mx-1 rounded-0"
                    :prepend-inner-icon="'$search'"
                    dense
                    outlined
                    clearable
                  ></v-select>
                </v-col>

                <i-button :text="'C/E Confirm'" :isCustom="true" v-if = "btnChief" :icon="'apply'" role="" class="pl-2" @click="btnChiefConfirm" />

                <i-button :text="'Caption Confirm'" :isCustom="true" v-if = "btnCaption" :icon="'apply'" role="" class="pl-2" @click="btnCaptionConfirm" />
              </v-row>
            </v-layout>
          </template>
        </i-card-top>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" class="pa-2">
        <i-card-vertical
          style="color: black"
          headerTitle="Tug-Boat Control"
          :useBtnList="[
            'btnAdd', //New
            'btnSave', //Save
            'btnDelete' //Delete
          ]"
          @btnAdd="btnAdd()"
          @btnSave="btnSave()"
          @btnDelete="btnDelete()"
        >
          <template v-slot:body>
            <v-layout column>
              <v-col cols="12" class="pa-0">
                <DxDataGrid
                  id="bas0010MainGrid"
                  class="listBox"
                  :ref="dxDataGridRef"
                  :data-source="bas0010MainGrid"
                  :remote-operations="false"
                  :hover-state-enabled="true"
                  :allow-column-resizing="true"
                  :allow-column-reordering="true"
                  :row-alternation-enabled="true"
                  :show-borders="true"
                  :width="grid.width"
                  :show-row-lines="true"
                  key-expr="id"
                  :focused-row-enabled="true"
                  :disablePagination="false"
                  :column-hiding-enabled="false"
                  :column-auto-width="true"
                  :on-row-inserted="e => e.component.navigateToRow(e.key)"
                  @editing-start="bas0010EditingStart"
                  @cellPrepared="cellPrepared"
                >
                  <DxPaging :enabled="false" />
                   <DxEditing :allow-updating="true" :allow-adding="true" mode="cell" />
                   <DxSelection select-all-mode="allMode" :show-check-boxes-mode="checkBoxesMode" mode="multiple"                    
                   />
                  <DxColumn
                    data-field="shipno"
                    :caption="$t('Ship No')"
                    width="100"
                    data-type="string"
                    alignment="center"
                    css-class="devest-grid-header-require"
                    :allow-editing="true"
                  >
                    <DxLookup :data-source="listShip" display-expr="code" value-expr="code" />
                  </DxColumn>

                  <DxColumn
                    data-field="shipnm"
                    :caption="$t('Ship Name')"
                    width="300"
                    data-type="string"
                    alignment="left"
                    css-class="devest-grid-header-require"
                    :allow-editing="false"
                  />
                  <DxColumn caption="Start Time" alignment="center">
                    <DxColumn
                      data-field="fday"
                      caption="Date"
                      width="120"
                      data-type="date"
                      format="yyyy-MM-dd"
                      alignment="center"
                      :set-cell-value="frDaySelect"
                    />
                    <DxColumn data-field="fhhmm" caption="Time" width="70" data-type="string" alignment="center" :editor-options="{ maxLength: 4 }"/>
                      <!-- <DxLookup :data-source="tugTimeList" display-expr="timeNm" value-expr="codeName" />
                    </DxColumn> -->
                  </DxColumn>
                  <DxColumn caption="Finish Time" alignment="center">
                    <DxColumn
                      data-field="tday"
                      caption="Date"
                      width="120"
                      data-type="date"
                      format="yyyy-MM-dd"
                      alignment="center"
                      :set-cell-value="toDaySelect"
                    />
                    <DxColumn data-field="thhmm" caption="Time" width="70" data-type="string" alignment="center"  :editor-options="{ maxLength: 4 }"/>
                      <!-- <DxLookup :data-source="tugTimeList" display-expr="timeNm" value-expr="codeName" />
                    </DxColumn> -->
                  </DxColumn>
                  <DxColumn data-field="oiltime" :caption="$t('Oil Consumption')" width="120" data-type="number" alignment="right" />
                  <DxColumn caption="Place" alignment="center">
                    <DxColumn data-field="fjangso" caption="From" width="200" data-type="string" alignment="right" >
                      <DxLookup :data-source="listPlace" display-expr="name" value-expr="code" />
                    </DxColumn>
                    <DxColumn data-field="tjangso" caption="To" width="200" data-type="string" alignment="right" >
                      <DxLookup :data-source="listPlace" display-expr="name" value-expr="code" />
                    </DxColumn>
                  </DxColumn>
                  <DxColumn data-field="bunker" :caption="$t('Bunker')" width="80" data-type="number" alignment="right" />
                  <DxColumn data-field="mcode" :caption="$t('Purpose')" width="150" data-type="string" alignment="right" >
                    <DxLookup :data-source="listPurpose" display-expr="name" value-expr="code" />
                  </DxColumn>

                  <DxColumn data-field="fueloil" :caption="$t('Fuel Oil')" width="120" data-type="string" alignment="right" >
                    <DxLookup :data-source="listFuelOil" display-expr="name" value-expr="code" />
                  </DxColumn>

                  <DxColumn data-field="rmk" :caption="$t('Remark')" width="auto" data-type="string" alignment="left"  />
                </DxDataGrid>
              </v-col>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { DxDataGrid, DxEditing, DxColumn, DxLookup, DxSelection, DxPager } from 'devextreme-vue/data-grid'
import iButton from '@/components/common/iButton'
import DxDateBox from 'devextreme-vue/date-box'
import themes from 'devextreme/ui/themes'
import ICardVertical from '@/components/common/iCardVertical.vue'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import notify from 'devextreme/ui/notify' // message
import dayjs from 'dayjs'
import { copyTugboat, 
         tugBoatCnt, 
         getAlreadyConfirm, 
         getEmpNo, 
         getPurpose, 
         getPlace, 
         getShipNo, 
         getTugBoat, 
         search5000List, 
         createTugBoat, 
         deleteTugBoat, 
         confirmSign } from '@/api/view/pp/20/v20a5000.js'
import { getCmCode, getCmChildCode} from '@/api/system/cmCodeManage'
import moment from 'moment'
import {getDateFormat, getCurrentDate } from '@/utils/common.js'

export default {
  name: 'v20a5000pc',
  mixins: [baseview, BaseDataGrid],

  components: {
    ICardVertical,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxDateBox,
    DxLookup,
    DxSelection,
    DxPager,
    iButton
  },
  data() {
    return {
      dxDataGridRef: 'dxDataGridRef',
      bas0010MainGrid: [],
      listClickData: null,

      listFuelOil: [
        {code: 'M', name: 'Ship moving'},
        {code: 'S', name: 'Support'},
      ],
      checkBoxesMode: 'onClick', // themes.current().startsWith('material') ? 'always' : 'onClick',
      //Common code combo box list
      codegrList: [],

      //Date
      modal_from: '',
      modal_to: '',

      fday: '',
      tday: '',
      //Time select
      fhhmm: null,
      thhmm: null,
      modal_ftime: false,
      modal_ttime: false,
      tugBoat: '',
      tugBoatCopy: '',
      listTugBoat: [],

      listShip: [],
      listRShip: [],
      shipNo: '',

      fjangso: '',
      tjangso: '',
      listPlace: [],
      tugTimeList: [],
      listPurpose: [],

      // movDate: moment().format('YYYY-MM-DD'),
      movDate: '',
      format: '##:##',
      empCaption: '',
      btnCaption: false,
      empChief: '',
      btnChief: false,
      countChief: 0,
      countCaption: 0,
      countAll: 0,
      writeYn: this.$gUtil.getWriteYn(),
    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.dxDataGridRef)
    },


  },
  methods: {
    getStrFormat(date) {
      this.movDate = date
      return getDateFormat(date)
    },
    async setCombo() {

      let params = { tugNo: '' }

      //getPurpose
      const purpose = async () => {
        await getPurpose(params).then(result => {
          result.list.forEach(item => {
            this.listPurpose.push({
              name: item.name,
              code: item.code
            })
          })
        })
      }
      // getShipNo
      const ship = async () => {
        await getShipNo(params).then(result => {
          result.list.forEach(item => {
            this.listShip.push({
              name: item.name,
              code: item.code
            })
          })
        })
      }

      // getTugBoat
      const tugboat = async () => {
        await getTugBoat(params).then(result => {
          this.listTugBoat = result.list
        })
      }

      // getTugBoat
      const place = async () => {
        await getPlace(params).then(result => {
            result.list.forEach(item => {
            this.listPlace.push({
              name: item.name,
              code: item.code
            })
          })
        })
      }

      //     
      await Promise.all([ship(), tugboat(), place(), purpose()])
        .catch(ex => {
          //    this.$qMsgBox.show(this, this.$gUtil.getSqlError(ex), ['ok']);
        })
        .finally(() => {
          this.$qLoading.hide()
        })
    },

    //PK part modification[edit] function control
    bas0010EditingStart(e) {
       this.gridMainInstance.selectRows(e.data.id, true)
      if (e.data.__created__ === false) {
        if ( e.column.dataField === 'shipno' || e.column.dataField === 'fday' || e.column.dataField === 'fhhmm' ) {
          e.cancel = true
        }
      } else {
        if (e.column.dataField === 'shipnm' ) {
          e.cancel = true
        }
      }
    },
    cellPrepared(e) {
      if (e.rowType === 'data') {
        if (e.rowType === 'data' && e.rowIndex >= 0) {
          // console.log('e.data.__created__', e.data.__created__)
          if (!e.data.__created__) {
            if ( e.column.dataField === 'shipno' || e.column.dataField === 'fday' || e.column.dataField === 'fhhmm')  {
              e.cellElement.classList.add('cancel-editable-cell')
            }
          }
        }
      }
    },
    frDaySelect(newData , value , currentRowData){
      // this.dataList[currentRowData.id - 1].fday = getDateFormat(value)
      newData.fday = getDateFormat(value)
    },
    toDaySelect(newData , value , currentRowData){
      newData.tday = getDateFormat(value)
    },

    btnCopy(){

          if (!this.tugBoatCopy) {
            this.vToastify(this.$t('Please, select Tug-Boat To.'), 'warn')
            return
          }

          let params = {
                tugNo: this.tugBoat,
                tugNoCopy: this.tugBoatCopy,
                moveDate: this.movDate,
                userId: this.$store.state.user.userId,
            }

          tugBoatCnt(params).then(result => {
            // console.log('===>result: ', result.body);
                if(result.body > 0){
                    this.vToastifyPrompt(
                        this.$t('Do you want to OVERWRITE?'),
                        'info',
                        current => {
                            this.openLoading('Loading...')
                            copyTugboat(params)
                                .then(res => {                         
                                  notify(this.$t('Data was copied successfully!'), 'success', 3000)
                                    
                                })
                                .catch(error => {
                                    // this.vToastify(this.$t('Có lỗi xảy ra trong khi cập nhật dữ liệu.'), 'warn')
                                    notify(error, 'error', 1500)
                                    this.endLoading()
                                })
                                .finally(() => {   
                                    this.doSearchMainList()                        
                                    this.endLoading()
                                })
                        },
                        null,
                        true
                    )   
                }else{
                   try{
                        this.openLoading('searching')
                        copyTugboat(params).then(res => {
                          // console.log('res', res)
                         notify(this.$t('Data was copied successfully!'), 'success', 3000)
                        })
                        .catch(error => {
                          this.vToastify(error, 'warn')
                          this.endLoading()
                        })
                        .finally(() => {
                          this.gridMainInstance.endUpdate()
                          this.doSearchMainList()
                        })
                      } finally{
                        this.endLoading()
                      }
                }
            })
    },
    async btnChiefConfirm() {

      if (this.bas0010MainGrid.length === 0){
        this.vToastify(this.$t('No data to confirm!.'), 'warn')
        return
      }else{
        let params = {
                tugNo: this.tugBoat,
                moveDate: this.movDate,                
                authDiv: 'TI22',
                userId: this.empChief,
            }            
            this.vToastifyPrompt(
                this.$t('Do you want to sure confirm?'),
                'info',
                current => {
                    this.openLoading('Loading...')
                    confirmSign(params)
                        .then(res => {                         
                           notify(this.$t('Confirmed successfully!'), 'success', 3000)
                            
                        })
                        .catch(error => {
                            // this.vToastify(this.$t('Có lỗi xảy ra trong khi cập nhật dữ liệu.'), 'warn')
                            notify(error, 'error', 1500)
                            this.endLoading()
                        })
                        .finally(() => {   
                            this.doSearchMainList()                        
                            this.endLoading()
                        })
                },
                null,
                true
            )
        // notify(this.$t('Confirmed successfully!'), 'success', 3000)
      }
      
    },
    async btnCaptionConfirm() {
      
      if (this.bas0010MainGrid.length === 0){
        this.vToastify(this.$t('No data to confirm!.'), 'warn')
        return
      }else{

        let params = {
                tugNo: this.tugBoat,
                moveDate: this.movDate,                
                authDiv: 'TI21',
                userId: this.empCaption,
            }
                 
            this.vToastifyPrompt(
                this.$t('Do you want to sure confirm?'),
                'info',
                current => {
                    this.openLoading('Loading...')
                    confirmSign(params)
                        .then(res => {
                         
                           notify(this.$t('Confirmed successfully!'), 'success', 3000)
                            
                        })
                        .catch(error => {
                            // this.vToastify(this.$t('Có lỗi xảy ra trong khi cập nhật dữ liệu.'), 'warn')
                            notify(error, 'error', 1500)
                            this.endLoading()
                        })
                        .finally(() => {   
                            this.doSearchMainList()                        
                            this.endLoading()
                        })
                },
                null,
                true
            )

        // notify(this.$t('Confirmed successfully!'), 'success', 3000)
      }
    },
    btnSearch() {
      this.doSearchMainList()
    },
    doSearchMainList(event) {
      this.bas0010MainGrid = []
      this.listClickData = null

      if (!this.tugBoat) {
          this.vToastify(this.$t('Please, select Tug-Boat No.'), 'warn')
          return
      }

      this.openLoading('searching')
      let params = {}
      if (event) {
        params = {
          tugNo: '',
          moveDate: ''
        }
      } else {
        params = {
          tugNo: this.tugBoat,
          moveDate: this.movDate
        }
      }
      //Check Caption/ Chief engineer already confirm or not?
      this.getConfirmed(this.tugBoat, this.movDate)

      search5000List(params)
          .then(res => {       
            this.bas0010MainGrid = res.list  
             this.setSign(this.tugBoat)     
            // if (this.bas0010MainGrid.length > 0){
            //   // Set Disable Caption/ Chief engineer button?           
            //   this.setSign(this.tugBoat)     
            // }          
          })
          .finally(() => {                      
            this.endLoading()          
          })
      
    },
    getConfirmed(tugno, mDate){
      // get Employee Caption
      let params1 = { tugNo: tugno, authDiv: '1', moveDate: mDate}
      getAlreadyConfirm(params1).then(res => {
          this.countCaption = res.list.length
      }) 

      // get Employee Chief Engineer
      let params2 = { tugNo: tugno, authDiv: '2', moveDate: mDate }
      getAlreadyConfirm(params2).then(res => {
          this.countChief = res.list.length
      })

      // get Employee confirm All
      let params3 = { tugNo: tugno, authDiv: '3', moveDate: mDate }
      getAlreadyConfirm(params3).then(res => {
          this.countAll = res.list.length
      })
    },
    setSign(e){
      // get Employee Caption
      let params1 = { tugNo: e, authDiv: '1' }
      getEmpNo(params1).then(res => {          
          this.empCaption = res.list[0].empno
          if ((this.empCaption === this.$store.state.user.userId)&&(this.bas0010MainGrid.length > 0)&&(this.countCaption === 0)&&(this.countChief > 0)){
            this.btnCaption = true
          }
          else{
            this.btnCaption = false
          }
      }) 

      // get Employee Chief Engineer
      let params2 = { tugNo: e, authDiv: '2' }
      getEmpNo(params2).then(res => {          
          this.empChief = res.list[0].empno
          if ((this.empChief === this.$store.state.user.userId)&&(this.bas0010MainGrid.length > 0)&&(this.countChief === 0)&&(this.countCaption === 0)){
            this.btnChief = true
          }
          else{
            this.btnChief = false
          }
      })
    },
    btnAdd() {
        
        if (!this.writeYn) {
          this.vToastify(this.$t('You no have authority to Add.'), 'warn')
          return
        }

        if (!this.tugBoat) {
          this.vToastify(this.$t('Please, select Tug-Boat No.'), 'warn')
          return
        }

        if (this.countCaption > 0 ) {
        this.vToastify(this.$t('This Tug-Boat already confirmed by Caption!'), 'warn')
        return
      }

        // get Employee confirm All
        let params3 = { tugNo: this.tugBoat, authDiv: '3', moveDate: this.movDate }
        getAlreadyConfirm(params3).then(res => {         
            this.countAll = res.list.length
            if (this.countAll > 0) {
              this.vToastify(this.$t('This date of Tug-Boat already confirm!'), 'warn')
              return
            }else{
              let check = this.bas0010MainGrid.findIndex(e => e.__created__ === true)
              // if (check === -1) {
                let newRow = {
                  id: this.bas0010MainGrid.length + 1 + '',
                  tugno: this.tugBoat,
                  shipno: '',
                  fday: this.movDate,
                  fhhmm: '',
                  tday: this.movDate,
                  thhmm: '',
                  fjangso: '',
                  tjangso: '',
                  bunker: '',
                  mcode: '',
                  rmk: '',
                  fueloil: '',
                  oiltime: '',
                  userId: this.$store.state.user.userId,

                  __modified__: false,
                  __created__: true
                }
                this.gridMainInstance.newRow(newRow)
                // console.log('newRow: ', newRow)
                this.gridMainInstance.selectRows(newRow.id, true)
                this.gridMainInstance.option('focusedRowIndex', -1)
                // this.gridMainInstance.option('focusedRowKey', this.gridMainInstance.option('dataSource').length)
                
              // } else {
              //   notify('A new row exists.', 'error', 1500)
              // } 
            } 
        }).finally(() => {  
           this.endLoading() 
        }) 
    },
    async btnSave() {

        if (!this.writeYn) {
          this.vToastify(this.$t('You no have authority to Save.'), 'warn')
          return
        }

        let message = ''
         await this.gridMainInstance.saveEditData()

        //let selectedMainRows = []

        const selectedMainRows =  await this.gridMainInstance.getSelectedRowsData()
        //  console.log('selectedMainRows', selectedMainRows)
        if (!selectedMainRows.length) {
          this.vToastify(this.$t('SelectCheck'), 'warn')
          return
        }

        //Validity check
        for (let row of selectedMainRows) {
          // console.log('==>row', row)
          // if (row.captionYN ==='Y' || row.chiefYN === 'Y') {
          //   this.vToastify('This Tug-Boat already confirmed!', 'warn')
          //   return
          // }

          if (!row.tugno || !row.shipno) {
            this.vToastify(this.$t('requiredCheck') + '[Ship No]', 'warn')
            return
          }

          if (!row.fday) {
            this.vToastify(this.$t('requiredCheck') + '[start date]', 'warn')
            return
          }

          if (!row.tday) {
            this.vToastify(this.$t('requiredCheck') + '[Finish date]', 'warn')
            return
          }

          if (!row.fhhmm||row.fhhmm==='') {
            this.vToastify(this.$t('requiredCheck') + '[Start time]', 'warn')
            return
          }
          
          if (!row.thhmm||row.thhmm==='') {
            this.vToastify(this.$t('requiredCheck') + '[Finish time]', 'warn')
            return
          }

          if (row.fday > row.tday) {
            this.vToastify('Shift finish date must be greater than shift start date!', 'warn')
            return
          }

          if ((row.fday === row.tday)&&(row.fhhmm > row.thhmm)) {
            this.vToastify('Shift finish time must be greater than shift start time!', 'warn')
            return
          }     
          if (row.fhhmm.length != 4) {
            this.vToastify('Please input shift start time correctly!', 'warn')
            return
          }
          if (row.thhmm.length != 4) {
            this.vToastify('Please input shift finish time correctly!', 'warn')
            return
          }

          if((row.fhhmm.substr(0,2) >= '00')&&(row.fhhmm.substr(0,2) <= '24')){
            if((row.fhhmm.substr(3,1) >= '0')&&(row.fhhmm.substr(3,1) <= '6')){
            
            }else{
              this.vToastify('Please check shift start time!', 'warn')
              return
            }
          }else{
              this.vToastify('Please check shift start time!', 'warn')
              return
          }

          if((row.thhmm.substr(0,2) >= '00')&&(row.thhmm.substr(0,2) <= '24')){
            if((row.thhmm.substr(3,1) >= '0')&&(row.thhmm.substr(3,1) <= '6')){
            
            }else{  
              this.vToastify('Please check shift finish time!', 'warn')
              return
            }
          }else{
              this.vToastify('Please check shift finish time!', 'warn')
              return
          }

          if (row.__created__ !== true) {
            row.__modified__ = true
            // row.tugno = this.tugBoat
          }

          Object.keys(row).forEach(key => {
              if(key !== '__created__' && key !== '__modified__') {
                row[key] = row[key] ? row[key] : ''
              }
          })

           row.userId = this.$store.state.user.userId

        }
        // console.log('beforeCurrent')
        try{
              this.openLoading('searching')
              await createTugBoat(selectedMainRows, true).then(res => {
                // console.log('res', res)
                this.doSearchMainList(false)
                message = selectedMainRows[0].__created__ == true ? 'Saved' : 'changed'
                notify(this.$t(message), 'success', 3000)
              })
              .catch(error => {
                this.vToastify(error, 'warn')
                this.endLoading()
              })
              .finally(() => {
                this.gridMainInstance.endUpdate()
                this.doSearchMainList()
              })
            } finally{
              this.endLoading()
            }
      
    },
    async btnDelete() {

        if (!this.writeYn) {
          this.vToastify(this.$t('You no have authority to Delete.'), 'warn')
          return
        }

        let message = ''
       await this.gridMainInstance.saveEditData()
        let selectedMainRows = await this.gridMainInstance.getSelectedRowsData()
        if (!selectedMainRows.length) {
          this.vToastify(this.$t('SelectCheck'), 'warn')
          return
        }

        //Validity check
        for (let row of selectedMainRows) {
          // console.log('btnDelete', row);
          if (row.captionYN ==='Y' || row.chiefYN === 'Y') {
            this.vToastify('You cant not delete! This Tug-Boat already confirmed!', 'warn')
            return
          }
         
          if (row.__created__ !== true) {
            row.__modified__ = true
          }
        }
        this.vToastifyPrompt(
          this.$t('doDeleteData'),
          'info',
          current => {
            this.openLoading()
            this.gridMainInstance.beginUpdate()
            selectedMainRows.forEach(item => {
              // 
            })
            // console.log('selectedMainRows : ', selectedMainRows)
            deleteTugBoat(selectedMainRows, true)
              .then(res => {
                this.doSearchMainList(false)
                message = 'deleted'
                notify(this.$t(message), 'success', 3000)
              })
              .catch(error => {
                this.vToastify(error, 'warn')
              })
              .finally(() => {
                this.gridMainInstance.endUpdate()
                this.endLoading()
              })
          },
          null,
          true
        )
      
    },

  },
  mounted() {
    // console.log("writeYn: ", this.writeYn );
    this.btnCaption = false
    this.btnChief   = false

    let toDay = new Date
        toDay.setDate(toDay.getDate());
        this.movDate = toDay

    // setTimeout(() => this.gridMainInstance.refresh(), 100)
    // this.doSearchMainList(true)
  },
  created() {
    this.setCombo()
  },
  beforeMount() {
    let param = {
      makerCd: this.$store.state.user.makerCd,
      code: '',
      codegr: '',
      prtCode: 'TIME_FULL',
      userFlag: 'Y'
    }
    //tugTimeList
    Promise.all([getCmChildCode(param)])
      .then(res => {
        res[0].list.forEach(e => {
          if (e.codeName != null) {
            e.timeNm = e.codeName.substring(0, 2) + ':' + e.codeName.substring(2)
          } else {
            e.timeNm = ''
          }
        })

        this.tugTimeList = res[0].list
      })
      .catch(error => {})
  }
}
</script>
<style lang="less" scoped></style>
